/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyInvitationsMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyInvitations. */
export class FamilyInvitations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyInvitations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Graph Family APIs to return family invitations.
   * @summary Retrieves the invitations of the current user's family.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyInvitationsGetFamilyInvitationsResponse>
   */
  getFamilyInvitations(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyInvitationsGetFamilyInvitationsResponse>;
  /**
   * @param callback The callback
   */
  getFamilyInvitations(callback: coreHttp.ServiceCallback<Models.FamilyInvitation[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyInvitations(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.FamilyInvitation[]>): void;
  getFamilyInvitations(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.FamilyInvitation[]>, callback?: coreHttp.ServiceCallback<Models.FamilyInvitation[]>): Promise<Models.FamilyInvitationsGetFamilyInvitationsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getFamilyInvitationsOperationSpec,
      callback) as Promise<Models.FamilyInvitationsGetFamilyInvitationsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getFamilyInvitationsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/invitations",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyInvitation"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
